import {Box} from 'src/design/atoms/Box';
import React from 'react';

import type {CourseDefinitionSafeResponse} from 'src/api/ProactApiClient';

export interface CourseSummaryCardProps {
  course: CourseDefinitionSafeResponse;
}
export const CourseSummaryCard: React.FC<CourseSummaryCardProps> = ({
  course,
}) => {
  return (
    <Box>
      {course.isRenewalRequired === true ? (
        <p>
          The course is set to renew in {course.renewalPeriodDays} days. That
          means you will need to take this training again then.
        </p>
      ) : (
        <></>
      )}
      {course.isAttemptLimited === true ? (
        <p>
          The course has limited attempts. You may attempt it{' '}
          {course.attemptLimit} times within a {course.attemptLockoutPeriodDays}{' '}
          day period.
        </p>
      ) : (
        <></>
      )}
      {course.isCertificateGenerated === true ? (
        <p>
          This course generates a certificate. You'll be able to access it when
          you've passed the training.
        </p>
      ) : (
        <p>
          This course does not generate a certificate. You'll still be able to
          see your training record after the training is finished.
        </p>
      )}
    </Box>
  );
};
